module.exports = __webpack_public_path__ + "img/icon_sec3_04.f06997dd.png";